import { app_login_principal_RowClass, app_mst_role_ext_RowInterface, app_mst_role_line_RowInterface, app_mst_role_RowClass, app_perm_set_hdr_RowClass, app_perm_set_line_RowClass, bl_applet_login_subject_link_RowClass } from "blg-akaun-ts-lib";

// a mixture of AppLoginPrincipalContainerModel and UserAppletContainerModel
export class UserModel {
    // contains info about user mobile ID
    app_login_principal_mobile: app_login_principal_RowClass = new app_login_principal_RowClass();
    // contains info about user email ID
    app_login_principal_email: app_login_principal_RowClass = new app_login_principal_RowClass();
    // contains info about this applet they downloaded
    bl_applet_login_subject_link: bl_applet_login_subject_link_RowClass = new bl_applet_login_subject_link_RowClass();
    main_email: any;
    main_phone: any;
    userModel: any;
}

export class RoleModel {
    app_mst_role: app_mst_role_RowClass = new app_mst_role_RowClass();
    app_mst_role_exts: app_mst_role_ext_RowInterface[] = [];
    app_mst_role_lines: app_mst_role_line_RowInterface[] = [];
}

export class PermSetModel {
    app_perm_set_hdr: app_perm_set_hdr_RowClass = new app_perm_set_hdr_RowClass();
    app_perm_set_lines: app_perm_set_line_RowClass[] = [];
}

export class PermissionSetModel {
    app_perm_set_hdr: app_perm_set_hdr_RowClass = new app_perm_set_hdr_RowClass();
    permSetLines: PermSetLine[] = [];
}

export class PermSetLine {
    app_perm_set_line: app_perm_set_line_RowClass = new app_perm_set_line_RowClass();
    default_target_view_name: string;
    default_target_hdr_name: string;
}